module.exports = __webpack_public_path__ + "img/img2-4.3ecc77e1.png";